import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import { useCurrentCompanyId } from "hooks/auth";
import { unwrap } from "newui/utils/apiResponse";
import type { UserListItem } from "../../../types/userInvite";

const deactivateUser = async (userId: number): Promise<UserListItem> => {
  const response = await apiV1.post<UserListItem>(`users/${userId}/deactivate`);
  return unwrap<UserListItem>(response.data);
};

export const useDeactivateUserMutation = () => {
  const queryClient = useQueryClient();
  const companyId = useCurrentCompanyId();

  return useMutation<UserListItem, Error, number>({
    mutationFn: deactivateUser,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users", companyId] });
    },
  });
};
